const table = [
  {
    prop: 'department',
    label: 'Nombre',
    minWidth: 200
  },
]
export default table
